"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetUploadIcon24Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.NetUploadIcon24Solid = forwardRef_1.forwardRef('NetUploadIcon24Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M6.247 8.621A1.5 1.5 0 1 1 4.253 6.38L9.51 1.708a3.75 3.75 0 0 1 4.982 0l5.256 4.67a1.5 1.5 0 0 1-1.994 2.243L13.5 4.841V16.5a1.5 1.5 0 0 1-3 0V4.84L6.247 8.621Z" }),
        react_1.default.createElement("path", { d: "M2 21.5A1.5 1.5 0 0 1 3.5 20h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 2 21.5Z" })));
});
